angular.module('app').directive("reloadIframe", [
    '$compile',
    function ($compile) {
        return {
            restrict: "A",
            link: function (scope, element, attributes) {

                $(element).get(0).onload = function (event) {
                    contentWindow = event.target.contentWindow || event.target.contentDocument
                };
                var version = attributes.version,
                    contentWindow,
                    watcher = attributes.$observe("version", function (newVal) {
                        if (newVal == version) {
                            return
                        }
                        var url = scope.settings.cssUrl;
                        if (!!url) {
                            if (url.indexOf("?") == url.lastIndexOf("?")) {
                                (url += "?version=" + new Date().getTime())
                            } else {
                                (url += "&version=" + new Date().getTime())
                            }
                        }
                        contentWindow && contentWindow.postMessage && contentWindow.postMessage({action : "addCss", cssUrl: url}, "*");
                        /* watcher();
                         version = newVal;
                         var template = '<iframe reload-iframe  version="{{version}}" ng-init="frameSrc = trustSrc(settings.cssIframeUrl)" ng-src="{{frameSrc}}" style="height: 700px; width: 1376px;"></iframe>';
                         template = angular.element(template);
                         $(element).replaceWith(template);
                         $compile(template)(scope);*/
                    });
            }
        }
    }
]);